goog.provide("shadow.js.shim.module$$mui$material$CardActions$default");
shadow.js.shim.module$$mui$material$CardActions$default = shadow.js.shim.module$$mui$material$CardActions.default;
